// Branded types for type safety
export type SteamID64 = string & { readonly __brand: 'SteamID64' };
export type SteamID32 = string & { readonly __brand: 'SteamID32' };
export type VanityName = string & { readonly __brand: 'VanityName' };
export type Days = number & { readonly __brand: 'Days' };
export type UnixTimestamp = number & { readonly __brand: 'UnixTimestamp' };
export type BanCount = number & { readonly __brand: 'BanCount' };
export type Minutes = number & { readonly __brand: 'Minutes' };

// Type constructors
export const SteamID64 = (value: string): SteamID64 => value as SteamID64;
export const SteamID32 = (value: string): SteamID32 => value as SteamID32;
export const VanityName = (value: string): VanityName => value as VanityName;
export const Days = (value: number): Days => value as Days;
export const UnixTimestamp = (value: number): UnixTimestamp => value as UnixTimestamp;
export const BanCount = (value: number): BanCount => value as BanCount;
export const Minutes = (value: number): Minutes => value as Minutes;

export interface SteamPlayer {
    steamid: SteamID64;
    personaname: string;
    profileurl: string;
    avatar: string;
    avatarmedium: string;
    avatarfull: string;
    timecreated?: UnixTimestamp;
}

export interface BanInfo {
    SteamId: SteamID64;
    CommunityBanned: boolean;
    VACBanned: boolean;
    NumberOfVACBans: BanCount;
    DaysSinceLastBan: Days;
    NumberOfGameBans: BanCount;
    EconomyBan: string;
}

export interface Friend {
    steamid: SteamID64;
    relationship: string;
    friend_since: UnixTimestamp;
}

export interface FriendData {
    player: SteamPlayer;
    bans: BanInfo;
}

export interface OwnedGame {
    appid: number;
    playtime_forever: Minutes;
}

export interface ProfileSummary {
    id64: SteamID64;
    persona: string;
    profileUrl: string;
    recentNames?: string[];
    vacBanned: boolean;
    vacBans: BanCount;
    daysSinceLastBan: Days;
    gameBans: BanCount;
    timeCreated?: UnixTimestamp;
    friendCount: number;
    friendVacCount: BanCount;
    friendGameCount: BanCount;
    cs2PlaytimeMinutes?: Minutes;
}

export interface ParsedSteamInput {
    type: 'steamid64' | 'vanity' | 'steamid32' | 'steamid' | 'steamid3';
    value: string;
}
